import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { ParamData } from "../../../types/Param";
import { getLoginCount } from "../../../api/LogReport";
import { LogReportData } from "../../../types/LogReport";

interface LoginTrendProps {
  data: ParamData; // { startingFrom, endingOn }
}

const LoginTrend: React.FC<LoginTrendProps> = ({ data }) => {
  const [reportData, setReportData] = useState<LogReportData[]>([]);
  const [categories, setCategories] = useState<string[]>([]);
  const [counts, setCounts] = useState<number[]>([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await getLoginCount(data); // API call
        setReportData(resp);

        // Convert API data into chart-friendly arrays
        const newCategories = resp.map((x) =>
          new Date(x.date).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
          })
        );

        const newCounts = resp.map((x) => Number(x.count));

        setCategories(newCategories);
        setCounts(newCounts);
      } catch (err) {
        console.error("Error loading login count:", err);
      }
    };

    if (data.startingFrom && data.endingOn) {
      getData();
    }
  }, [data.startingFrom, data.endingOn]);

  // Apex chart config
  const options: ApexCharts.ApexOptions = {
    chart: {
      id: "login-trend-chart",
      toolbar: { show: false },
    },
    xaxis: {
      categories: categories,
      title: { text: "Date" },
    },
    yaxis: {
      title: { text: "Login Count" },
      min: 0,
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: ["#1E90FF"],
    dataLabels: {
      enabled: false,
    },
    grid: {
      borderColor: "#e1e1e1",
    },
  };

  const series = [
    {
      name: "Logins",
      data: counts,
    },
  ];

  return <Chart options={options} series={series} type="line" height={325} />;
};

export default LoginTrend;
